<div class="mat-elevation-z8">
  <div class="mat-table-wrapper">
    <mat-table #table [dataSource]="dataSource" matSort matSortDirection="asc" matSortDisableClear cdkDropList
      cdkDropListLockAxis="x" cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)"
      Group>

      <ng-container matColumnDef="status">
        <mat-header-cell [crud-column-header]="columns.column('status')" *matHeaderCellDef mat-sort-header cdkDropList
          cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.Ranger.status">
          Status
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.status | refDecode:'RANGER_STATUS' | async}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="rangerId">
        <mat-header-cell [crud-column-header]="columns.column('rangerId')" *matHeaderCellDef mat-sort-header cdkDropList
          cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.Ranger.rangerId">
          Ranger Id
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.rangerId | number:'1.0-2':'en-GB'}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="businessUnit.buId">
        <mat-header-cell [crud-column-header]="columns.column('businessUnit.buId')" *matHeaderCellDef mat-sort-header
          cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.Ranger.businessUnit">
          Business Unit
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.businessUnit?.buId}} - {{element.businessUnit?.name}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="costCentre.ccId">
        <mat-header-cell [crud-column-header]="columns.column('costCentre.ccId')" *matHeaderCellDef mat-sort-header
          cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.Ranger.costCentre">
          Cost Centre
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.costCentre?.ccId}} - {{element.costCentre?.name}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="rangerSource.rangerSourceMapId">
        <mat-header-cell [crud-column-header]="columns.column('rangerSource.rangerSourceMapId')" *matHeaderCellDef
          mat-sort-header cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.Ranger.rangerSource">
          Ranger Source
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.rangerSource?.rangerSourceMapId}} - {{element.rangerSource?.sourceName}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="volunteerRanger">
        <mat-header-cell [crud-column-header]="columns.column('volunteerRanger')" *matHeaderCellDef
          mat-sort-header cdkDropList cdkDropListLockAxis="x"
          cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
          class="search-column-small" i18n="@@type.Ranger.volunteerRanger">
          Volunteer Ranger
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          <mat-icon *ngIf="element.volunteerRanger">check_box</mat-icon>
          <mat-icon *ngIf="!element.volunteerRanger">check_box_outline_blank</mat-icon>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="wildlifeManagerRanger">
            <mat-header-cell [crud-column-header]="columns.column('wildlifeManagerRanger')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.Ranger.wildlifeManagerRanger">
                Wildlife Manager Ranger 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              <mat-icon *ngIf="element.wildlifeManagerRanger">check_box</mat-icon><mat-icon *ngIf="!element.wildlifeManagerRanger">check_box_outline_blank</mat-icon>
            </mat-cell>
          </ng-container>  

      <ng-container matColumnDef="provisionalRanger">
        <mat-header-cell [crud-column-header]="columns.column('provisionalRanger')" *matHeaderCellDef
          mat-sort-header cdkDropList cdkDropListLockAxis="x"
          cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
          class="search-column-small" i18n="@@type.Ranger.provisionalRanger">
          Provisional Ranger
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          <mat-icon *ngIf="element.provisionalRanger">check_box</mat-icon>
          <mat-icon *ngIf="!element.provisionalRanger">check_box_outline_blank</mat-icon>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="addr1">
        <mat-header-cell [crud-column-header]="columns.column('addr1')" *matHeaderCellDef mat-sort-header cdkDropList
          cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.Ranger.addr1">
          Addr1
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.addr1}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="addr2">
        <mat-header-cell [crud-column-header]="columns.column('addr2')" *matHeaderCellDef mat-sort-header cdkDropList
          cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.Ranger.addr2">
          Addr2
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.addr2}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="addr3">
        <mat-header-cell [crud-column-header]="columns.column('addr3')" *matHeaderCellDef mat-sort-header cdkDropList
          cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.Ranger.addr3">
          Addr3
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.addr3}}
        </mat-cell>
      </ng-container>


      <ng-container matColumnDef="createdBy">
        <mat-header-cell [crud-column-header]="columns.column('createdBy')" *matHeaderCellDef mat-sort-header
          cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.Ranger.createdBy">
          Created By
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.createdBy}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="createdDate">
        <mat-header-cell [crud-column-header]="columns.column('createdDate')" *matHeaderCellDef mat-sort-header
          cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.Ranger.createdDate">
          Created Date
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.createdDate | uimDateTimeFormat}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="updatedBy">
        <mat-header-cell [crud-column-header]="columns.column('updatedBy')" *matHeaderCellDef mat-sort-header
          cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.Ranger.updatedBy">
          Updated By
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.updatedBy}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="updatedDate">
        <mat-header-cell [crud-column-header]="columns.column('updatedDate')" *matHeaderCellDef mat-sort-header
          cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.Ranger.updatedDate">
          Updated Date
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.updatedDate | uimDateTimeFormat}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="email">
        <mat-header-cell [crud-column-header]="columns.column('email')" *matHeaderCellDef mat-sort-header cdkDropList
          cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-medium"
          i18n="@@type.Ranger.email">
          Email
        </mat-header-cell>
        <mat-cell class="search-column-medium" *matCellDef="let element">
          {{element.email}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="name">
        <mat-header-cell [crud-column-header]="columns.column('name')" *matHeaderCellDef mat-sort-header cdkDropList
          cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-medium"
          i18n="@@type.Ranger.name">
          Name
        </mat-header-cell>
        <mat-cell class="search-column-medium" *matCellDef="let element">
          {{element.name}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="postcode">
        <mat-header-cell [crud-column-header]="columns.column('postcode')" *matHeaderCellDef mat-sort-header cdkDropList
          cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.Ranger.postcode">
          Postcode
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.postcode}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="town">
        <mat-header-cell [crud-column-header]="columns.column('town')" *matHeaderCellDef mat-sort-header cdkDropList
          cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.Ranger.town">
          Town
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.town}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="actions" stickyEnd>
        <mat-header-cell class="search-column-actions mat-elevation-z9" *matHeaderCellDef>
          <span i18n="@@common.actions">Actions</span>
          <app-column-picker-dialog-launcher [columns]="columns">
          </app-column-picker-dialog-launcher>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="search-column-actions mat-elevation-z9">

          <app-action-button *ngFor="let action of actions" [action]="action" [actionArgs]="[element]">
          </app-action-button>
          
          <button class="action-button" *ngIf="allowsEdit(element)" mat-raised-button color="primary"
            [routerLink]="editRoute(element)" [queryParams]="editRouteQueryParams()" i18n="@@actions.edit"
            id="actions.edit">Edit</button>
          <button class="action-button" [queryParams]="viewRouteQueryParams()" *ngIf="allowsView(element)"
            mat-raised-button color="primary" [routerLink]="viewRoute(element)" i18n="@@actions.view"
            id="actions.view">View</button>
          <button class="action-button" *ngIf="allowsDelete(element)" mat-raised-button color="accent"
            (click)="deleteWithConfirmation(element)" i18n="@@actions.delete" id="actions.delete">Delete</button>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="columns.displayedColumns" class="search-table"></mat-header-row>
      <mat-row *matRowDef="let row; columns: columns.displayedColumns;" class="search-table"></mat-row>

    </mat-table>
  </div>
  <mat-paginator [length]="pageInfo.totalElements" [pageSize]="pageInfo.size" [pageSizeOptions]="pageSizes">
  </mat-paginator>
</div>